"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "company",
    path: "/companies/:id",
    component: "Company",
    params: [{
            name: "id",
            prop: "oid",
        },
    ]
});
let Company = class Company extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    role;
    onRole(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("role");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    messages;
    tabManager;
    async $$load_tabManager() {
        return new this.$app.utils.LazyTabManager();
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_company', { parameters: { id: this.oid }, asResource: true });
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['messages', 'tabManager', 'item', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    create: {
                        own: this.$fn.pgettext("Company|Header", "New own company"),
                        partner: this.$fn.pgettext("Company|Header", "New partner"),
                    },
                    parent: {
                        own: this.$fn.pgettext("Company|Header", "Companies"),
                        partner: this.$fn.pgettext("Company|Header", "Partners"),
                    },
                    delete: {
                        own: this.$fn.pgettext("Company|Header", "Delete own company"),
                        partner: this.$fn.pgettext("Company|Header", "Delete partner"),
                    },
                },
                tabManager: null,
                item: null,
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_modalBindings: {
                    noHeader: true,
                    contentClass: "p-0",
                    noPrimaryButton: true,
                    noCloseButton: true,
                    size: "full-screen",
                },
            },
        };
    }
    get effectiveRole() {
        if (this.loaded) {
            return this.item ? (this.item.role || this.role) : this.role;
        }
        return null;
    }
    get parentRouteName() {
        if (this.loaded) {
            return this.effectiveRole == 'own' ? 'app.ownCompanies' : 'app.partners';
        }
        return null;
    }
    get isOwnCompany() {
        if (this.loaded) {
            return this.effectiveRole === 'own';
        }
        return null;
    }
    get isPartnerCompany() {
        if (this.loaded) {
            return this.effectiveRole === 'partner';
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.oid == null && this.messages.create[this.role],
                    this.item && this.item.snapshot('name'),
                ],
                icon: this.$config.company.icons[this.role || this.item.role],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2656_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_6705964765214521_success(event, scope) {
        return await this.actions.evh_6705964765214521_success.executeFromDOM(this, event, scope);
    }
    async evh_6806515264385235_success(event, scope) {
        return await this.actions.evh_6806515264385235_success.executeFromDOM(this, event, scope);
    }
    async evh_5477420070495986_reload(event, scope) {
        return await this.actions.evh_5477420070495986_reload.executeFromDOM(this, event, scope);
    }
    async evh_6337614691287098_reload(event, scope) {
        return await this.actions.evh_6337614691287098_reload.executeFromDOM(this, event, scope);
    }
    async evh_2406129194387753_reload(event, scope) {
        return await this.actions.evh_2406129194387753_reload.executeFromDOM(this, event, scope);
    }
    async evh_1840158740026147_reload(event, scope) {
        return await this.actions.evh_1840158740026147_reload.executeFromDOM(this, event, scope);
    }
    async evh_4071170783051919_reload(event, scope) {
        return await this.actions.evh_4071170783051919_reload.executeFromDOM(this, event, scope);
    }
    async evh_7713630524832656_reload(event, scope) {
        return await this.actions.evh_7713630524832656_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2656 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2656_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2655 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2656,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2655],
        });
        const act_2248226175642056_closeModal_2658 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_2657 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_2658,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2657],
        });
        const act_8320016629450276_reloadComponentData_2660 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_2659 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_2660,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_2659],
        });
        const act_6705964765214521_closeComponent_2662 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_6705964765214521_success_2661 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_closeComponent_2662,
            event: "success",
            displayName: "closeComponent",
        });
        const evh_6705964765214521_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_success_2661],
        });
        const act_6806515264385235_reloadComponentData_2664 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6806515264385235_success_2663 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_reloadComponentData_2664,
            event: "success",
            displayName: "reloadComponentData",
        });
        const evh_6806515264385235_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6806515264385235_success_2663],
        });
        const act_5477420070495986_reloadComponentData_2666 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5477420070495986_reload_2665 = new core_1.actions.EventHandlerImpl({
            action: act_5477420070495986_reloadComponentData_2666,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_5477420070495986_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5477420070495986_reload_2665],
        });
        const act_6337614691287098_reloadComponentData_2668 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6337614691287098_reload_2667 = new core_1.actions.EventHandlerImpl({
            action: act_6337614691287098_reloadComponentData_2668,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_6337614691287098_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6337614691287098_reload_2667],
        });
        const act_2406129194387753_reloadComponentData_2670 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2406129194387753_reload_2669 = new core_1.actions.EventHandlerImpl({
            action: act_2406129194387753_reloadComponentData_2670,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_2406129194387753_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2406129194387753_reload_2669],
        });
        const act_1840158740026147_reloadComponentData_2672 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1840158740026147_reload_2671 = new core_1.actions.EventHandlerImpl({
            action: act_1840158740026147_reloadComponentData_2672,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_1840158740026147_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1840158740026147_reload_2671],
        });
        const act_4071170783051919_reloadComponentData_2674 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_4071170783051919_reload_2673 = new core_1.actions.EventHandlerImpl({
            action: act_4071170783051919_reloadComponentData_2674,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_4071170783051919_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4071170783051919_reload_2673],
        });
        const act_7713630524832656_reloadComponentData_2676 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7713630524832656_reload_2675 = new core_1.actions.EventHandlerImpl({
            action: act_7713630524832656_reloadComponentData_2676,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7713630524832656_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7713630524832656_reload_2675],
        });
        return {
            act_7315092382398562_closeModal_2656,
            evh_7315092382398562_close_2655,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_2658,
            evh_2248226175642056_close_2657,
            evh_2248226175642056_close,
            act_8320016629450276_reloadComponentData_2660,
            evh_8320016629450276_clickPreventStop_2659,
            evh_8320016629450276_clickPreventStop,
            act_6705964765214521_closeComponent_2662,
            evh_6705964765214521_success_2661,
            evh_6705964765214521_success,
            act_6806515264385235_reloadComponentData_2664,
            evh_6806515264385235_success_2663,
            evh_6806515264385235_success,
            act_5477420070495986_reloadComponentData_2666,
            evh_5477420070495986_reload_2665,
            evh_5477420070495986_reload,
            act_6337614691287098_reloadComponentData_2668,
            evh_6337614691287098_reload_2667,
            evh_6337614691287098_reload,
            act_2406129194387753_reloadComponentData_2670,
            evh_2406129194387753_reload_2669,
            evh_2406129194387753_reload,
            act_1840158740026147_reloadComponentData_2672,
            evh_1840158740026147_reload_2671,
            evh_1840158740026147_reload,
            act_4071170783051919_reloadComponentData_2674,
            evh_4071170783051919_reload_2673,
            evh_4071170783051919_reload,
            act_7713630524832656_reloadComponentData_2676,
            evh_7713630524832656_reload_2675,
            evh_7713630524832656_reload,
            reload: act_8320016629450276_reloadComponentData_2660,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Company.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Company.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Company.prototype, "role", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('role'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Company.prototype, "onRole", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], Company.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Company.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], Company.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Company.prototype, "onSize", null);
Company = __decorate([
    (0, vue_property_decorator_1.Component)()
], Company);
exports.default = Company;
vue_property_decorator_1.Vue.component("Company", Company);
